import React, { useCallback , useState} from 'react';
import { PvE, PvP, AllBuilds } from './values/optimizer/breakpoints';
import STATS from './values/trees';
import { MAX_TREE_LEVEL } from './constants';
import './optimizer.scss';

const upgradeCost = ({
  branch,
  currentLevel,
  nextLevel,
  treeLevel,
  juiceLeft,
}) => {
  if(
    currentLevel < 0 ||
    nextLevel < 0 ||
    currentLevel > Math.min(treeLevel, MAX_TREE_LEVEL) - 10 ||
    nextLevel > Math.min(treeLevel, MAX_TREE_LEVEL) - 10 ||
    nextLevel <= currentLevel
  ) return false;
  const currentSum = parseInt(STATS[branch][currentLevel].SUM);
  const nextSum = parseInt(STATS[branch][nextLevel].SUM);
  const cost = nextSum - currentSum;
  return (cost <= juiceLeft) ? cost : false;
}

export default ({
  celerityLevel,
  setCelerityLevel,
  sustenanceLevel,
  setSustenanceLevel,
  sorceryLevel,
  setSorceryLevel,
  mightLevel,
  setMightLevel,
  fortitudeLevel,
  setFortitudeLevel,
  treeLevel,
  juiceLeft,
  setJuiceLeft,
  totalJuice,
}) => {
  const [resetTree, setResetTree] = useState(true);
  const updateResetTree = useCallback(({ target: { checked } }) => setResetTree(checked), [setResetTree]);

  const optimizeTree = useCallback((key) => {
    let newJuiceLeft = juiceLeft;
    let newCelerityLevel = celerityLevel;
    let newMightLevel = mightLevel;
    let newFortitudeLevel = fortitudeLevel;
    let newSustenanceLevel = sustenanceLevel;
    let newSorceryLevel = sorceryLevel;

    const build = AllBuilds[key];
    if(resetTree) {
      newJuiceLeft = totalJuice;
      newCelerityLevel = 0;
      newMightLevel = 0;
      newFortitudeLevel = 0;
      newSustenanceLevel = 0;
      newSorceryLevel = 0;
    }
    build.forEach(({ branch, level, reason }) => {
      let currentLevel = 0;
      switch(branch) {
        case 'sustenance':
          currentLevel = newSustenanceLevel;
          break;
        case 'sorcery':
          currentLevel = newSorceryLevel;
          break;
        case 'might':
          currentLevel = newMightLevel;
          break;
        case 'fortitude':
          currentLevel = newFortitudeLevel;
          break;
        case 'celerity':
          currentLevel = newCelerityLevel;
          break;
        default:
          break;
      };
      const cost = upgradeCost({ branch, currentLevel, nextLevel: level, treeLevel, juiceLeft: newJuiceLeft });
      if(cost !== false) {
        console.log(`Upgrading ${branch} to ${level} because ${reason}`);
        newJuiceLeft -= cost;
        switch (branch) {
          case 'sustenance':
            newSustenanceLevel = level;
            break;
          case 'sorcery':
            newSorceryLevel = level;
            break;
          case 'might':
            newMightLevel = level;
            break;
          case 'fortitude':
            newFortitudeLevel = level;
            break;
          case 'celerity':
            newCelerityLevel = level;
            break;
          default:
            break;
        };
      }
    });
    setJuiceLeft(newJuiceLeft);
    setCelerityLevel(newCelerityLevel);
    setMightLevel(newMightLevel);
    setFortitudeLevel(newFortitudeLevel);
    setSorceryLevel(newSorceryLevel);
    setSustenanceLevel(newSustenanceLevel);
  }, [
    totalJuice,
    celerityLevel,
    setCelerityLevel,
    mightLevel,
    setMightLevel,
    fortitudeLevel,
    setFortitudeLevel,
    sorceryLevel,
    setSorceryLevel,
    sustenanceLevel,
    setSustenanceLevel,
    juiceLeft,
    setJuiceLeft,
    resetTree,
    treeLevel,
  ]);

  return (
    <div id="optimizer">
      <span>
        Note: These do not take Rosaline's priority into account. These are only meant as a quick, convenient starting point.
      </span>
      <label>
        Reset Tree First?
        <input id="reset-tree" type='checkbox' checked={resetTree} onChange={updateResetTree} />
      </label>
      <span>
        PvP Builds:
      </span>
      <div className="builds">
        {
          Object.keys(PvP).map(key => (
            <button key={key} onClick={() => optimizeTree(key)}>
              {key}
            </button>
          ))
        }
      </div>
      <span>
        PvE Builds:
      </span>
      <div className="builds">
        {
          Object.keys(PvE).map(key => (
            <button key={key} onClick={() => optimizeTree(key)}>
              {key}
            </button>
          ))
        }
      </div>
    </div>
  );
};